import React from "react";
import { Switch, Route, HashRouter } from "react-router-dom";
import { Box } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";

import { EdenredLogo } from "./common/icons/EdenredLogo";
import VehicleSingleRegistrySyncHistoryWidgetPage from "./views/Vehicles/pages/VehicleSingleRegistrySyncHistoryWidgetPage";
import { LoginWidget, LogoutWidget } from "./components/auth/Callback";
import VehicleTablePage from "./views/Vehicles/pages/VehicleTablePage";
import VehicleSingleRegistryUploadWidgetPage from "./views/Vehicles/pages/VehicleSingleRegistryUploadWidgetPage";

export const ROUTER_MAP_PATH = {
  vehicles: {
    homePage: "/company/:cid/vehicles",
    uploadPage: "/company/:cid/vehicles/upload",
    syncHistoryPage: "/company/:cid/vehicles/sync-history",
  },
};

export const DefaultPage = () => (
  <Box sx={{ flex: 1, height: "100%", alignContent: "center" }}>
    <EdenredLogo />
    <Box sx={{ maxWidth: "400px", margin: "1rem auto", textAlign: "left" }}>
      <Alert severity="error">
        Não foi possível carregar as informações no momento. Tente novamente.
      </Alert>
    </Box>
  </Box>
);

export const NotFoundPage = () => (
  <Box sx={{ flex: 1, height: "100%", alignContent: "center" }}>
    <EdenredLogo />
    <Box sx={{ maxWidth: "400px", margin: "1rem auto", textAlign: "left" }}>
      <Alert severity="error">
        O recurso solicitado não está disponível no momento.
      </Alert>
    </Box>
  </Box>
);

export default class EmbeddedRoutes extends React.Component {
  render() {
    return (
      <HashRouter>
        <Switch>
          <Route exact component={DefaultPage} path="/default" />
          <Route exact component={LoginWidget} path="/signin-oidc" />
          <Route exact component={LogoutWidget} path="/logout" />
          <Route
            exact
            path={ROUTER_MAP_PATH.vehicles.homePage}
            component={VehicleTablePage}
          />
          <Route
            exact
            path={ROUTER_MAP_PATH.vehicles.uploadPage}
            component={VehicleSingleRegistryUploadWidgetPage}
          />
          <Route
            exact
            path={ROUTER_MAP_PATH.vehicles.syncHistoryPage}
            component={VehicleSingleRegistrySyncHistoryWidgetPage}
          />

          <Route exact component={NotFoundPage} />
        </Switch>
      </HashRouter>
    );
  }
}
